import React from "react";

export const ragBg = { green: "bg-emerald-600", amber: "bg-[#C9A24B]", red: "bg-[#DC2626]" };
export const ragText = { green: "text-emerald-400", amber: "text-[#C9A24B]", red: "text-[#DC2626]" };

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-heading font-light tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-2 text-sm max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-[#131c31] border border-white/10 rounded-lg ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, tone = "default", icon, testid }) {
  const toneMap = {
    default: "text-white",
    success: "text-emerald-400",
    gold: "text-[#C9A24B]",
    danger: "text-[#DC2626]",
  };
  return (
    <Card className="p-5 hover:-translate-y-1 transition-transform duration-200" data-testid={testid}>
      <div className="flex items-start justify-between">
        <p className="text-[11px] tracking-[0.1em] uppercase font-semibold text-slate-400">{label}</p>
        {icon && <span className="text-slate-500">{icon}</span>}
      </div>
      <p className={`mt-3 text-3xl font-heading font-semibold ${toneMap[tone]}`}>{value}</p>
      {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
    </Card>
  );
}

export function RagDot({ status }) {
  return <span className={`inline-block w-2.5 h-2.5 rounded-full ${ragBg[status] || "bg-slate-500"}`} />;
}

export function Empty({ text }) {
  return <div className="text-center py-16 text-slate-500 text-sm">{text}</div>;
}
